import React from 'react';
import { motion } from 'framer-motion';
import { Star, StarIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const testimonials = [{
  quote: 'Pensé que nunca iba a volver a ver mi cara como la tengo hoy en día...',
  author: 'Maria R.'
}, {
  quote: 'Kate ha sanado mi piel de tantas maneras. Es muy raro encontrar una esteticista que genuinamente se preocupe por tu proceso.',
  author: 'Ana E.'
}, {
  quote: 'Llegué con un acné super alborotado y descontrolado. Quedé súper encantada.',
  author: 'Yolyney A.'
}];
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  return <section id="resenas" className="py-12 md:py-24 bg-brand-white relative border-t border-brand-gold/10" data-id="element-440" data-mp="182rpshgvmjq8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-441" data-mp="2yexs0b5fxhiv">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-442" data-mp="32gsql7vzlgsy">
          {/* Left Column: Emotional Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-443" data-mp="2v0sun8y4a43d">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-brown mb-4 md:mb-6" data-id="element-444" data-mp="2zudvr9v0be6s">
              {t('testimonials.title')}
            </h2>
            <div className="w-16 h-1 bg-brand-gold mb-8" data-id="element-445" data-mp="274f2115vasvs"></div>

            <div className="space-y-6 text-lg text-brand-charcoal" data-id="element-446" data-mp="275zy4v7tyjvr">
              <p className="font-medium" data-id="element-447" data-mp="2m2h75fsjrmf5">{t('testimonials.p1')}</p>
              <p className="text-xl font-serif text-brand-gold-light italic" data-id="element-448" data-mp="2h1jpr5fd2wep">
                {t('testimonials.highlight')}
              </p>
              <p data-id="element-449" data-mp="18uackh05f45">{t('testimonials.p2')}</p>
              <p data-id="element-450" data-mp="3shhu4vzlgu9l">{t('testimonials.p3')}</p>
              <p className="font-medium" data-id="element-451" data-mp="3sgggqkv3vvop">{t('testimonials.p4')}</p>
              <p data-id="element-452" data-mp="3fk3gbp87axu">{t('testimonials.p5')}</p>
            </div>
          </motion.div>

          {/* Right Column: Testimonials */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="space-y-6" data-id="element-453" data-mp="8cah6sdk5ug3">
            <p className="text-sm uppercase tracking-widest text-brand-gold font-semibold mb-8 text-center lg:text-left" data-id="element-454" data-mp="3lt9qt65gov77">
              {t('testimonials.subtitle')}
            </p>

            {testimonials.map((testimonial, index) => <div key={index} className="bg-brand-cream p-8 rounded-sm shadow-sm border border-brand-gold/5 relative" data-id="element-455" data-mp="2y373f3chsdex" data-mpi={index}>
                <div className="flex mb-4 text-brand-gold" data-id="element-456" data-mp="330fq9h8l55mi">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-457" data-mp="1k51mubztbmuq" data-mpi={i} />)}
                </div>
                <p className="text-brand-charcoal italic mb-4" data-id="element-458" data-mp="1b6hd40c8cnin">
                  "{testimonial.quote}"
                </p>
                <p className="font-semibold text-brand-brown" data-id="element-459" data-mp="167wdo34sy7v9">
                  — {testimonial.author}
                </p>
              </div>)}

            <p className="text-center lg:text-left text-brand-charcoal font-medium mt-8" data-id="element-460" data-mp="11aee33cod4zx">
              {t('testimonials.footer')}
            </p>

            <div className="text-center lg:text-left mt-6" data-id="element-461" data-mp="sf6q3u9mkuw1">
              <a href="https://share.google/aeNeaqJ9AadTchr2e" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-medium text-brand-gold hover:text-brand-gold-light transition-colors border border-brand-gold/30 px-4 py-2 rounded-sm" data-id="element-462" data-mp="sdlstwvxexuh">
                <StarIcon className="w-4 h-4 fill-current" data-id="element-463" data-mp="2dm9rqo9zsmih" />
                {t('testimonials.button')}
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}